import React, { useState } from 'react';
import { Outlet, useOutletContext } from 'react-router-dom';
import { Navbar } from '../components/layout/Navbar';
import { BottomNav } from '../components/layout/BottomNav';
import { ToastContainer } from 'react-toastify';

interface PrivateLayoutContextType {
    toggleBottomNav: () => void;
    hideBottomNav: boolean;
}

export const PrivateLayout: React.FC = () => {
    const [hideBottomNav, setHideBottomNav] = useState(false);

    const toggleBottomNav = () => setHideBottomNav((prev) => !prev);

    return (
        <div className="min-h-screen bg-gray-50 dark:bg-gray-900 transition-colors pt-14">
            <Navbar />
            <main className="container mx-auto px-4 py-6">
                <Outlet context={{ toggleBottomNav, hideBottomNav }} />
            </main>
            <BottomNav hidden={hideBottomNav} />
            <ToastContainer />
        </div>
    );
};

export const usePrivateLayoutContext = () => {
    return useOutletContext<PrivateLayoutContextType>();
};